import { injectable } from 'inversify';
import { ImportMode } from '../generated/types';
import { TranslationService } from '../services/translationService';
import { CsvInputService } from './csvInput';
import { MappableImportInputService } from './mappableImportInput';

@injectable()
export class VolunteersImportInputService extends MappableImportInputService {
    static override IMPORT_COLUMNS_DEFAULT = {
        ...MappableImportInputService.IMPORT_COLUMNS_DEFAULT,

        /* CreateUpdate key */
        Email: 'email',
        TicketId: 'ticketId'
    };

    static override IMPORT_COLUMNS_REQUIRED = (mode: ImportMode) =>
        mode === ImportMode.Update
            ? [VolunteersImportInputService.IMPORT_COLUMNS_DEFAULT.Id]
            : [VolunteersImportInputService.IMPORT_COLUMNS_DEFAULT.Email];

    // Needed to stop 'The number of constructor arguments in the derived class VolunteersImportInputService must be >= than the number of constructor arguments of its base class' errors
    constructor(
        protected override csvInputService: CsvInputService,
        translationService: TranslationService
    ) {
        super(csvInputService, translationService);
    }
}
